import React, { useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Box, Fade } from "@mui/material";
import { useGetEcgDetails, useGetEcgGraph } from "../api/EcgReports";
import ShortReport from "./Reusables/ReportCards/ShortReport";
import FullReport from "./Reusables/ReportCards/FullReport";
import SendInterpretationDialog from "./Reusables/ReportCards/SendInterpretationDialog";

export function ReportPreview({
  type,
  Link,
  handleRefreshList,
  reportData,
}) {
  const { id: paramId } = useParams();
  const location = useLocation();
  const lastValidId = useRef(null);
  const reportId = React.useMemo(() => {
    if (paramId) {
      lastValidId.current = paramId;
      return paramId;
    }

    if (location.hash) {
      const id = location.hash.replace("#", "");
      lastValidId.current = id;
      return id;
    }

    return lastValidId.current;
  }, [paramId, location.hash]);

  const [argEcg, setArgEcg] = useState({ reset: false });
  const [createModal, setCreateModal] = useState(false);
  const { EcgReport, isLoading } = useGetEcgDetails({ argEcg }, reportId);
  const { ecgGraph, isLoading: isLoadingGraph } = useGetEcgGraph(
    { argEcg },
    reportId,
  );

  const handleSent = () => {
    setArgEcg({ reset: true });
    handleRefreshList?.();
  };

  return (
    <>
      {type == "short" ? (
        <Fade in={true}>
          <Box>
            <ShortReport
              Link={Link}
              data={EcgReport}
              setCreateModal={setCreateModal}
              ecgGraph={ecgGraph}
              isLoadingGraph={isLoadingGraph}
              reportData={reportData}
            />
          </Box>
        </Fade>
      ) : (
        <FullReport
          data={EcgReport}
          setCreateModal={setCreateModal}
          ecgGraph={ecgGraph}
          isLoadingGraph={isLoadingGraph}
          isLoading={isLoading}
        />
      )}

      <SendInterpretationDialog
        open={createModal}
        onClose={() => setCreateModal(false)}
        report={EcgReport}
        onSent={handleSent}
      />
    </>
  );
}

export default ReportPreview;
